import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    buttons: {
        marginTop: '30px',
        marginBottom: '80px'
    }
}));

export default useStyles